// 节点类型定义
export const nodeTypes = [
  { type: 'rect', name: '对象', icon: '📦', color: '#70E483' },
  { type: 'circle', name: '属性', icon: '⚪', color: '#52c41a' },
  { type: 'diamond', name: '关系', icon: '💎', color: '#fa8c16' },
  { type: 'polygon', name: '过程', icon: '📐', color: '#722ed1' },
  // { type: 'dynamic-group', name: '分组(可拖动文字)', icon: '🗂️', color: '#13c2c2' },
];

export interface NodeType {
  type: string;
  name: string;
  icon: string;
  color: string;
}

// 分组类型枚举
export enum GroupType {
  /** 状态分组 - 默认类型 */
  STATE = 'state',
  /** 值分组 */
  VALUE = 'value',
}
